/* eslint-disable header/header */
export const name = "@azure/msal-browser";
export const version = "2.33.0";
